<div class="appComponent">
  <app-nav-bar *ngIf="environment.classicGap"></app-nav-bar>
  <app-nav-bar-warranties
    *ngIf="!environment.classicGap"></app-nav-bar-warranties>
  <router-outlet class="outlet"></router-outlet>
</div>
